import { useRef } from 'react';
import api from 'api';
import { useDispatch, useReduxState } from 'hooks';
import { ModalButtonWithForm, User } from 'components/common';
import { EmailMessageEditor, FormGroup } from 'components/common/form';

import type { FormApi } from 'informed';
import type { EmailTemplateData, UserWithBasicData } from 'shared-types';

interface Props {
  emailTemplates: EmailTemplateData[];
  emailTemplatesDefault: EmailTemplateData;
  targetUser: UserWithBasicData;
  updateUsers: (params: any) => Promise<void>;
}

const GroupUsersInviteSingle = ({
  emailTemplates,
  emailTemplatesDefault,
  targetUser,
  updateUsers
}: Props) => {
  const formApi = useRef<FormApi>(undefined);

  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { group }
  } = useReduxState();

  const handleSubmit = async (values) => {
    const data = {
      emailAddress: targetUser.email,
      emailContent: values.email
    };

    const response = await api.post(
      `/admin/groups/${group.id}/users-invite`,
      data
    );

    const errorEmails = Object.keys(response.data.errors);
    if (errorEmails && errorEmails.length) return false;

    await updateUsers({});

    formApi.current.reset();
    dispatch.addNotice({
      text: messages.commonSendEmailInviteSuccess,
      type: 'success'
    });
  };

  if (!emailTemplatesDefault) return null;

  const initialValues = {
    email: {
      ...emailTemplatesDefault.email,
      selectedTemplateIdentifier: emailTemplatesDefault.identifier
    }
  };

  return (
    <ModalButtonWithForm
      buttonIcon="paper-plane"
      buttonSize="header"
      buttonText={messages.commonSendEmailInvite}
      initialValues={initialValues}
      modalActionText={messages.commonSend}
      modalTitle={messages.commonSendEmailInvite}
      modalWidth="wide"
      onSubmit={handleSubmit}
      setFormApi={(api) => (formApi.current = api)}
    >
      {() => (
        <div>
          <FormGroup label={messages.commonRecipient}>
            <User enableProfileLink={true} user={targetUser} />
          </FormGroup>

          <EmailMessageEditor
            availableTemplates={emailTemplates}
            id={`group-users-invite-single-${targetUser.id}`}
            style={{ marginTop: 20 }}
          />
        </div>
      )}
    </ModalButtonWithForm>
  );
};

export default GroupUsersInviteSingle;
